export default "__VITE_ASSET__Bpv2X9m6__"